import { render, staticRenderFns } from "./IdentificacionPrivadaStep.vue?vue&type=template&id=81bac3fe"
import script from "./IdentificacionPrivadaStep.vue?vue&type=script&setup=true&lang=js"
export * from "./IdentificacionPrivadaStep.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports